// Shared-organisation (canonical record) trust state, for the admin pages.
// Mirrors backend services/canonical_verification.py.

const FIELD_LABELS = { privacy_email: 'data-protection email', address: 'postal address', website: 'website' };

/** 'Verified' (by an admin), 'Verified by reply' (the organisation
 * acknowledged a request from its own domain) or 'Pending'. */
export const verificationLabel = (r) => {
  if (!r?.admin_verified) return 'Pending';
  return r.verified_via === 'reply' ? 'Verified by reply' : 'Verified';
};

/** Plain-English names of the contact fields still empty. */
export const missingFieldLabels = (r) =>
  Object.keys(FIELD_LABELS).filter((f) => !(r?.[f] || '').trim()).map((f) => FIELD_LABELS[f]);
